var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$lang('ERRORS:NOT_FOUND:TITLE-TEXT')))])}
var staticRenderFns = []

export { render, staticRenderFns }